import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./CaseStudies.css";
import ProjectCard from "./ProjectCard";
import { caseStudiesData } from "./caseStudiesData";

const chainCategories = [
  { name: "Aptos", icon: "https://cryptologos.cc/logos/aptos-apt-logo.png" },
  {
    name: "Arbitrum",
    icon: "https://cryptologos.cc/logos/arbitrum-arb-logo.png",
  },
  {
    name: "Avalanche",
    icon: "https://cryptologos.cc/logos/avalanche-avax-logo.png",
  },
  { name: "Base", icon: "https://cryptologos.cc/logos/ethereum-eth-logo.png" },
  {
    name: "Bitcoin",
    icon: "https://cryptologos.cc/logos/bitcoin-btc-logo.png",
  },
  { name: "BNB Chain", icon: "https://cryptologos.cc/logos/bnb-bnb-logo.png" },
  { name: "Celo", icon: "https://cryptologos.cc/logos/celo-celo-logo.png" },
  { name: "Cosmos", icon: "https://cryptologos.cc/logos/cosmos-atom-logo.png" },
  { name: "Cronos", icon: "https://cryptologos.cc/logos/cronos-cro-logo.png" },
  {
    name: "Ethereum",
    icon: "https://cryptologos.cc/logos/ethereum-eth-logo.png",
  },
  { name: "Fantom", icon: "https://cryptologos.cc/logos/fantom-ftm-logo.png" },
  {
    name: "Harmony",
    icon: "https://cryptologos.cc/logos/harmony-one-logo.png",
  },
  {
    name: "Immutable X",
    icon: "https://cryptologos.cc/logos/immutable-x-imx-logo.png",
  },
  {
    name: "Polygon",
    icon: "https://cryptologos.cc/logos/polygon-matic-logo.png",
  },
  { name: "Solana", icon: "https://cryptologos.cc/logos/solana-sol-logo.png" },
];

// function CaseStudiesOne() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [selectedChains, setSelectedChains] = useState([]);
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const navigate = useNavigate();
function CaseStudiesOne() {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedChains, setSelectedChains] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // ADD THIS
  const [visibleCount, setVisibleCount] = useState(9);

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const toggleChain = (chainName) => {
    setSelectedChains((prev) =>
      prev.includes(chainName)
        ? prev.filter((c) => c !== chainName)
        : [...prev, chainName],
    );
  };

  // RESET TO 9 WHEN SEARCH/FILTER CHANGES
  useEffect(() => {
    setVisibleCount(9);
  }, [debouncedSearch, selectedChains]);

  const filteredData = useMemo(() => {
    const search = debouncedSearch.toLowerCase().trim();

    return caseStudiesData.filter((project) => {
      if (!project) return false;

      const title = String(project.title || "").toLowerCase();
      const description = String(project.description || "").toLowerCase();

      const matchesSearch =
        title.includes(search) || description.includes(search);

      if (project.isPromo && search === "" && selectedChains.length === 0) {
        return true;
      }

      if (project.isPromo) return false;

      const matchesChain =
        selectedChains.length === 0 ||
        (Array.isArray(project.chains) &&
          project.chains.some((c) => selectedChains.includes(c)));

      return matchesSearch && matchesChain;
    });
  }, [debouncedSearch, selectedChains]);

  // VISIBLE PROJECTS
  const visibleProjects = filteredData.slice(0, visibleCount);

  //   const search = debouncedSearch.toLowerCase().trim();

  //   return caseStudiesData.filter((project) => {
  //     // protect against broken objects
  //     if (!project) return false;

  //     const title = String(project.title || "").toLowerCase();
  //     const description = String(project.description || "").toLowerCase();

  //     const matchesSearch =
  //       title.includes(search) || description.includes(search);

  //     // promo handling
  //     if (project.isPromo && search === "" && selectedChains.length === 0) {
  //       return true;
  //     }

  //     if (project.isPromo) return false;

  //     const matchesChain =
  //       selectedChains.length === 0 ||
  //       (Array.isArray(project.chains) &&
  //         project.chains.some((c) => selectedChains.includes(c)));

  //     return matchesSearch && matchesChain;
  //   });
  // }, [debouncedSearch, selectedChains]);
  return (
    <div className="cs-wrapper">
      {/* Hero Section */}
      <div
        className="cs-hero"
        style={{
          backgroundImage:
            "url(assets/img/marketing/accelerate_your_growth_hero_image.jpg)",
        }}
      >
        <div className="container">
          <div className="cs-hero-content">
            <p
              className="cs-hero-subtitle"
              style={{
                marginBottom: "16px",
                fontSize: "13px",
                fontWeight: 700,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                color: "#ffffff",
              }}
            >
              ✦ Case Studies
            </p>
            <h1 className="cs-hero-title">
              Explore the Best
              <br />
              Web3 DApps & Tools
            </h1>
            <p className="cs-hero-subtitle">
              Discover high-end decentralized solutions built and powered by
              Xeer Technology — from DeFi to infrastructure.
            </p>

            {/* Stats row */}
          </div>
        </div>
      </div>

      <div className="cs-container">
        <div className="cs-layout">
          {/* Sidebar */}

          {/* Main Content */}
          <div className="cs-content" style={{ flex: 1, minWidth: 0 }}>
            <div className="cs-mobile-filter-bar">
              <button
                className="cs-mobile-filter-btn"
                onClick={() => setIsFilterOpen(true)}
              >
                <i className="fas fa-sliders-h"></i> Filters
                {selectedChains.length > 0 && (
                  <span
                    style={{
                      background: "#fff",
                      color: "#6366f1",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 800,
                    }}
                  >
                    {selectedChains.length}
                  </span>
                )}
              </button>
            </div>

            <div className="cs-topbar">
              <div className="cs-search-box">
                <i className="fas fa-search cs-search-icon"></i>
                <input
                  type="text"
                  placeholder="Search projects, protocols, chains..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="cs-stats">
                {filteredData.length} of {caseStudiesData.length} results
              </div>
            </div>

            <div className="cs-grid">
              {filteredData.length > 0 ? (
                visibleProjects.map((project, idx) => (
                  <ProjectCard
                    key={project.id}
                    project={project}
                    index={idx}
                    onClick={(p) => navigate(`/case-studies/${p.id}`)}
                  />
                ))
              ) : (
                <div className="cs-empty-state">
                  <i
                    className="fas fa-ghost"
                    style={{
                      fontSize: "56px",
                      marginBottom: "24px",
                      opacity: 0.3,
                    }}
                  ></i>
                  <h3
                    style={{
                      fontSize: "22px",
                      fontWeight: 700,
                      marginBottom: "8px",
                    }}
                  >
                    No projects found
                  </h3>
                  <p style={{ color: "#64748b" }}>
                    Try adjusting your search or filters to discover more.
                  </p>
                </div>
              )}
            </div>

            {/* SHOW MORE BUTTON */}
            {filteredData.length > 9 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "40px",
                }}
              >
                {visibleCount < filteredData.length ? (
                  <button
                    onClick={() => setVisibleCount((prev) => prev + 9)}
                    style={{
                      padding: "14px 32px",
                      borderRadius: "14px",
                      border: "none",
                      background:
                        "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 10px 25px rgba(99,102,241,0.25)",
                      transition: "0.3s",
                    }}
                  >
                    Show More
                  </button>
                ) : (
                  <button
                    onClick={() => setVisibleCount(9)}
                    style={{
                      padding: "14px 32px",
                      borderRadius: "14px",
                      border: "1px solid #e2e8f0",
                      background: "#fff",
                      color: "#0f172a",
                      fontSize: "15px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    Show Less
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CaseStudiesOne;
